"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var base_1 = require("./base");
var Area = /** @class */ (function (_super) {
    __extends(Area, _super);
    function Area() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._reservedAttr = ["d"];
        _this._scaleX = d3.scaleLinear();
        _this._scaleY = d3.scaleLinear();
        return _this;
    }
    Area.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _xFunc: function (d, i) { return i; }, _minFunc: function (d) { return 0; }, _maxFunc: function (d) { return d; } });
    };
    Area.prototype.renderElement = function (node, d, i, g, h) {
        var _this = this;
        if (typeof this.area === "undefined") {
            this.area = d3.area();
        }
        var xFunc = h.op("_xFunc", true);
        var minFunc = h.op("_minFunc", true);
        var maxFunc = h.op("_maxFunc", true);
        if (this._options._scaleX) {
            this._scaleX = h.op("_scaleX", true);
        }
        else {
            this._scaleX
                .range([0, this._getGeometry("_width", true, d, i, g)])
                .domain(d3.extent(d.map(xFunc)));
        }
        if (this._options._scaleY) {
            this._scaleY = h.op("_scaleY", true);
        }
        else {
            var min = d3.min(d.map(minFunc));
            var max = d3.max(d.map(maxFunc));
            this._scaleY
                .range([this._getGeometry("_height", false, d, i, g), 0])
                .domain([min, max]);
        }
        this.area
            .x(function (d, i) { return _this._scaleX(xFunc(d, i)); })
            .y0(function (d, i) { return _this._scaleY(minFunc(d, i)); })
            .y1(function (d, i) { return _this._scaleY(maxFunc(d, i)); });
        node.attr("d", this.area);
    };
    Area.nodeName = "path";
    return Area;
}(base_1.BaseElement));
exports.Area = Area;
//# sourceMappingURL=area.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/element/area.js
// module id = 1141
// module chunks = 0 1